export enum LoanTypeList {
  NONE = '0',
  SINGLE = '1',
  JOINT = '2',
}
